export class TotalCost {

  public totalCustomerPrice = 0.0;
  public totalDealerPrice = 0.0;

  public totalCustomerVAT = 0.0;
  public totalDealerVAT = 0.0;

  public totalCustomerCost = 0.0;
  public totalDealerCost = 0.0;

}
